import API from 'js/lib/api';

export default API('/api/s12nSubscriptionWelcomeEmails.v1', {
  type: 'rest',
});
